export default "__VITE_ASSET__ChVAFdgM__"